import { Spin } from "antd";
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import styles from "../../../../../../pages/MessagePage/_component/Operation/style.module.scss";
import { messageActions } from "../../../../../../pages/MessagePage/reducer";
import { selectMessage } from "../../../../../../util/store/selectors";
import { getStore, useSelector } from "../../../../../../util/store/store";
import { CHAT_TYPE, operationType, tabMessage } from "../../../../../../util/varibles/constants";
import { checkLoadMore } from "../../../../../../util/varibles/global";
import Icon, { ICON_NAME } from "../../../../../Icon";
import { getSubInfoChatOp } from "../../../../constants";
import Message from "../../Message";
import stylesContainer from "../style.module.scss";

interface IProps {
    onOpenConversation(conversation: any): void
}


const Operation: React.FC<IProps> = (props) => {
    const operations = useSelector(state => state.message.operations);
    const operationsMore = useSelector(state => state.message.operationsMore);
    const loadingOperation = useSelector(state => state.message.loadingOperation);
    const dispatch = useDispatch();
    const rootRef = useRef<HTMLDivElement>(null);
    const isAutoLoadRef = useRef(false);

    useEffect(() => {
        if (rootRef.current) {
            if (operations.length > 0 && isAutoLoadRef.current && operationsMore && !loadingOperation) {
                isAutoLoadRef.current = false;
                const operationsIndex = selectMessage.operationsIndex(getStore());
                checkLoadMore(rootRef.current, () => {
                    dispatch(messageActions.getChatOfOpRequest({ index: operationsIndex + 1 }))
                })
            }
        }
    }, [operations, operationsMore, loadingOperation, dispatch]);

    const handleWheel = (e: any) => {
        if (!operationsMore || loadingOperation || !rootRef.current)
            return;

        const { deltaY } = e;
        const { scrollTop, scrollHeight, offsetHeight } = rootRef.current;
        const isScrolledToBottom = (scrollHeight - offsetHeight - (scrollTop + deltaY)) < 0;

        if (isScrolledToBottom && deltaY > 0) {
            const operationsIndex = selectMessage.operationsIndex(getStore());
            dispatch(messageActions.getChatOfOpRequest({ index: operationsIndex + 1 }))
        }
    }

    return <>
        <div className={stylesContainer['title']}>
            <div data-lev='name'>
                {tabMessage[CHAT_TYPE.OPERATION].name}
            </div>
            <div data-lev='action'>
                <div className='bt-ghost' data-icon={true} onClick={() => dispatch(messageActions.setNewConversationType(CHAT_TYPE.OPERATION))}>
                    <Icon icon={ICON_NAME.ADD_2} />
                </div>
            </div>
        </div>

        <div ref={rootRef} className={stylesContainer['container-content']} onWheel={handleWheel}>
            <div className={stylesContainer.content}>
                {operations.map((item, i) => {
                    const { group_chat = {} } = item || {};
                    const { id, name, operation_type } = group_chat;
                    const { icon } = operationType[operation_type] || {};
                    return <Message
                        title={<div className={styles['message-title']}>
                            <div>#{name}</div>
                            {getSubInfoChatOp(group_chat)}
                        </div>}
                        avatar={<div className={styles.avatar}>
                            <Icon icon={icon!} />
                        </div>}
                        key={id + i}
                        data={item}
                        onClick={() => props.onOpenConversation(item)}
                    />
                })}
            </div>
            {loadingOperation && <div className={stylesContainer.loading} data-empty={operations.length === 0}>
                <Spin />
            </div>}
        </div>
    </>;
};

export default Operation;

